const tenantIdpMappings = {
  pg: {
    loginUrl: `https://${process.env.REACT_APP_AWS_COGNITO_DOMAIN}/oauth2/authorize?identity_provider=PnG&response_type=token&client_id=${process.env.REACT_APP_AWS_COGNITO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_PG_CLIENT_REDIRECT_URI}&scope=email+openid+profile&prompt=login`,
    idpName: "Ping Federate",
  },
  alston: {
    loginUrl: `https://${process.env.REACT_APP_AWS_COGNITO_DOMAIN}/oauth2/authorize?identity_provider=Alston&response_type=token&client_id=${process.env.REACT_APP_AWS_COGNITO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_ALSTON_CLIENT_REDIRECT_URI}`,
    idpName: "Microsoft Entra ID",
  },
  [process.env.REACT_APP_NUMBER_GENERATOR_TENANT]: {
    loginUrl: `https://${process.env.REACT_APP_AWS_COGNITO_DOMAIN}/oauth2/authorize?identity_provider=Crowell&response_type=token&client_id=${process.env.REACT_APP_AWS_COGNITO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_CROWELL_CLIENT_REDIRECT_URI}`,
    idpName: "Microsoft Entra ID",
  },
};

const CLIENT_WITH_IDP = Object.keys(tenantIdpMappings);

export { tenantIdpMappings, CLIENT_WITH_IDP };
